// The kind of a form node. Drives dispatch in `SchemaToForm` (build),
// `BindBrandValidators` (resolve), and `CreateReactiveForm` (wrap):
//  - ATOM   : a leaf — its `validate` is a self-contained cast (unknown → T).
//  - CHOICE : a leaf backed by a named `choices` map (single or `multiple`).
//  - ARRAY  : a homogeneous list — `field` is the element form.
//  - OBJECT : a statically-keyed record — `fields` is a per-key form.
//  - ENUM   : a discriminated union — one object form per `enum` tag.
export const enum FormType {
  ATOM = "atom",
  CHOICE = "choice",
  ARRAY = "array",
  OBJECT = "object",
  ENUM = "enum",
}
